import { render } from "./BaseBtn.vue?vue&type=template&id=51b0f7e5&scoped=true"
import script from "./BaseBtn.vue?vue&type=script&lang=js"
export * from "./BaseBtn.vue?vue&type=script&lang=js"

import "./BaseBtn.vue?vue&type=style&index=0&id=51b0f7e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b0f7e5"]])

export default __exports__